// any operators needed throughout your application
import '../../operators';

import {
    AfterViewInit,
    Component,
    OnInit,
    ViewChild,
    ViewEncapsulation
} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { Observable } from 'rxjs/Observable';
import * as fromRootStore from '../../reducers/index';
import * as appConfigActions from '../../reducers/appconfig.actions';
import * as fromCommonStore from '../../store';
import * as commonActions from '../../store/actions/common.actions';
import { AuthService } from '../../services/index';

import { Store } from '@ngrx/store';
import * as _ from 'lodash';
import swal from 'sweetalert2';
import { CommonService, SubscribeService } from '../../services/index';
import { TabsComponent } from './tabs.component';
import { NotificationsComponent } from './notifications.component';
import { DashboardService } from "../../services/index";
import { Dashboard } from './dashboard.component';

@Component({
    moduleId: module.id,
    templateUrl: './home.component.html',
    //encapsulation: ViewEncapsulation.None
})

export class HomeComponent implements OnInit {

    title = 'app';
    @ViewChild(TabsComponent) tabsComponent;
    @ViewChild(NotificationsComponent) notificationsComponent;
    menus: any;
    allMenus: any;
    menuIcon: string = 'fa-arrow-left';
    @ViewChild('sideNavMenu') sideNavMenu;

    isauth$: Observable<boolean>;
    appVersion$: Observable<string>;
    HVBill: string;
    showMenu = false;
    isShowTrans = false;
    isShowMaster = false;
    isShowBillTrans = false;
    isShowChaTrans = false;
    isShowFolTrans = false;
    isShowDailyReports = false;
    isShowFolReports = false;
    isShowClientReports = false;
    isShowRetReports = false;
    isShowTrackReports = false;
    isShowSalesReports = false;
    isShowDailyHistoryReports = false;
    isShowNotOkReports = false;
    isShowAllBranchReports = false;
    isShowDstrReports = false;
    isShowAppoinmentReports = false;
    isShowStockReports = false;
    isShowReport = false;
    isShowServiceReports = false;
    isShowPurchaseReports = false;
    isShowSoldReports = false;
    isShowEdit = false;
    isShowTelecaller = false;
    isShowDoctor = false;
    private CurrentDate;
    isLoadMask: Promise<any>;
    items: any;
    transMenuObj: any;
    billTransMenuObj: any;
    chaTransMenuObj: any;
    folTransMenuObj: any;
    repMenuObj: any;
    dailRepMenuObj: any;
    folRepMenuObj: any;
    folHisRepMenuObj: any;
    notokRepMenuObj: any;
    allBranchRepMenuObj: any;
    dstrRepMenuObj: any;
    appoinmentRepMenuObj: any;
    stockRepMenuObj: any;
    retRepMenuObj: any;
    serviceRepMenuObj: any;
    soldRepMenuObj: any;
    cliRepMenuObj: any;
    salFolRepMenuObj: any;
    trackRepMenuObj: any;
    editRepMenuObj: any;
    purchaseRepMenuObj: any;
    menuContent: any;
    editMenuObj:any;
    telecallerMenuObj: any;
    doctorMenuObj: any;
    management: any;
    tabID: any;
    dataCorrection: any;
    aiMaster: any;

    constructor(private logger: NGXLogger, private commonService: CommonService,
        private store: Store<fromRootStore.State>, private comstore: Store<fromCommonStore.State>,
        private router: Router, private authService: AuthService, public subSer: SubscribeService, private dashboardService: DashboardService) {
        this.logger.debug('AppComponent Rendered');
        // console.log(TabsComponent);
        // this.tabsComponent = TabsComponent;
        // console.log(this);
        let that = this;
        this.CurrentDate = Date.now();
        setInterval(() => {
            that.CurrentDate = new Date();
        }, 1000);
    }

    ngOnInit() {
        // let that = this;
        // that.authService
        //         .logout({})
        //         .then((res: any) => {
        //             if (res.success) {
        //                 that.showMenu = true;
        //                 that.comstore.dispatch(new commonActions.IsAuth(true));
        //                 //localStorage.setItem('currentUser', 'Abdul');
        //                 that.router.navigate(['login'], { skipLocationChange: true });
        //             }
        //         })
        //         .catch((error: any) => {
        //             console.log(error);
        //         });
        //let menu = this.commonService.getMenus();
        //this.menus = _.groupBy(menu, 'parent');

        this.appVersion$ = this.store.select(fromRootStore.getAppVersion);
        //this.store.dispatch(new appConfigActions.SetAppVersion('1.0'));
        //console.log(this.appVersion$);
        this.subSer.publishReloadHomeGrid().subscribe(($e) => {
            // that.pageCallback({ offset: 0 });
            this.tabID = 'Dashboard';
        });
        this.comstore.select(fromCommonStore.getAuth).subscribe((auth: any) => {
            this.isauth$ = auth;
            this.HVBill = auth.fullname;
            this.tabID = 'Dashboard';
            //console.log(this.isauth$);
            if (this.isauth$['islogin']) {
                this.comstore.dispatch(new commonActions.LoadAllBrand());
                this.comstore.dispatch(new commonActions.LoadAllBrandModel());
                this.comstore.dispatch(new commonActions.LoadAllBranch());
                this.comstore.dispatch(new commonActions.LoadAllFollowUpStatus());
                this.comstore.dispatch(new commonActions.LoadAllReference());
                this.loadUserMenu();
                this.notificationsComponent.getnotificationList();
            }

        });

        this.subSer.publishTabID().subscribe(($e) => {
            this.addTab($e['tabGroup'], $e['tabid'], $e['params'], $e['tabParams']);
        });
       
    }
    
    public loadUserMenu() {
        let that = this;
        this.isLoadMask = this.commonService
            .getUserMenus()
            .then(function (res: any) {
                if (res.success) {
                    that.showMenu = true;
                    //TO MAINTAIN ALL MENUS
                    that.allMenus = _.groupBy(res.data, 'parent');
                    //TO FILTER ONLY VISIBLE TRUE MENU
                    let menus = _.filter(res.data, { 'visible': 'true' });
                    that.menus = _.groupBy(menus, 'parent');
                    that.items = _.filter(that.menus['Master'], { 'visible': 'true' });
                    that.transMenuObj = _.filter(that.menus['Transaction'], { 'visible': 'true' });
                    that.billTransMenuObj = _.filter(that.menus['billTransaction'], { 'visible': 'true' });
                    that.chaTransMenuObj = _.filter(that.menus['ChaTransaction'], { 'visible': 'true' });
                    that.folTransMenuObj = _.filter(that.menus['FolTransaction'], { 'visible': 'true' });
                    that.repMenuObj = _.filter(that.menus['Report'], { 'visible': 'true' });
                    that.dailRepMenuObj = _.filter(that.menus['dailyReport'], { 'visible': 'true' });
                    that.folRepMenuObj = _.filter(that.menus['folReport'], { 'visible': 'true' });
                    that.folHisRepMenuObj = _.filter(that.menus['dailyHistoryReport'], { 'visible': 'true' });
                    that.notokRepMenuObj = _.filter(that.menus['notokReport'], { 'visible': 'true' });
                    that.allBranchRepMenuObj = _.filter(that.menus['allBranchReport'], { 'visible': 'true' });
                    that.dstrRepMenuObj = _.filter(that.menus['dstrReport'], { 'visible': 'true' });
                    that.appoinmentRepMenuObj = _.filter(that.menus['appoinmentReport'], { 'visible': 'true' });
                    that.stockRepMenuObj = _.filter(that.menus['stockReport'], { 'visible': 'true' });
                    that.retRepMenuObj = _.filter(that.menus['retReport'], { 'visible': 'true' });
                    that.cliRepMenuObj = _.filter(that.menus['clientReport'], { 'visible': 'true' });
                    that.salFolRepMenuObj = _.filter(that.menus['salesReport'], { 'visible': 'true' });
                    that.trackRepMenuObj = _.filter(that.menus['trackReport'], { 'visible': 'true' });
                    /*                     that.editRepMenuObj = _.filter(that.menus['Edit'], { 'visible': 'true' });
                     */
                    that.editMenuObj = _.filter(that.menus['Edit'], { 'visible': 'true' });
                    that.purchaseRepMenuObj = _.filter(that.menus['purchaseReport'], { 'visible': 'true' });
                    that.serviceRepMenuObj = _.filter(that.menus['serviceTracking'], { 'visible': 'true' });
                    that.soldRepMenuObj = _.filter(that.menus['soldReport'], { 'visible': 'true' });
                    that.management = _.filter(that.menus['Management'], { 'visible': 'true' });
                    that.dataCorrection = _.filter(that.menus['DataCorrection'], { 'visible': 'true' });
                    that.aiMaster = _.filter(that.menus['AiMaster'], { 'visible': 'true' });
                    that.telecallerMenuObj = _.filter(that.menus['Telecaller'], { 'visible': 'true' });
                    that.doctorMenuObj = _.filter(that.menus['Doctor'], { 'visible': 'true' });

                    _.forIn(that.menus, function (value, key) {
                        if (key == 'Master') {
                            that.isShowMaster = true;
                        } else if (key == 'Transaction') {
                            that.isShowTrans = true;
                        } else if (key == 'billTransaction') {
                            that.isShowBillTrans = true;
                            that.isShowTrans = true;
                        } else if (key == 'ChaTransaction') {
                            that.isShowChaTrans = true;
                            that.isShowTrans = true;
                        } else if (key == 'FolTransaction') {
                            that.isShowFolTrans = true;
                            that.isShowTrans = true;
                        } else if (key == 'Report') {
                            that.isShowReport = true;
                        } else if (key == 'dailyReport') {
                            that.isShowDailyReports = true;
                            that.isShowReport = true;
                        } else if (key == 'folReport') {
                            that.isShowFolReports = true;
                            that.isShowReport = true;
                        } else if (key == 'retReport') {
                            that.isShowRetReports = true;
                            that.isShowReport = true;
                        } else if (key == 'clientReport') {
                            that.isShowClientReports = true;
                            that.isShowReport = true;
                        } else if (key == 'salesReport') {
                            that.isShowSalesReports = true;
                            that.isShowReport = true;
                        } else if (key == 'trackReport') {
                            that.isShowTrackReports = true;
                            that.isShowReport = true;
                        } else if (key == 'purchaseReport') {
                            that.isShowPurchaseReports = true;
                            that.isShowReport = true;
                        } else if (key == 'serviceTracking') {
                            that.isShowServiceReports = true;
                            that.isShowReport = true;
                        } else if (key == 'soldReport') {
                            that.isShowSoldReports = true;
                            that.isShowReport = true;
                        }
                        else if (key == 'dailyHistoryReport') {
                            that.isShowDailyHistoryReports = true;
                            that.isShowReport = true;
                        } else if (key == 'notokReport') {
                            that.isShowNotOkReports = true;
                            that.isShowReport = true;
                        } else if (key == 'allBranchReport') {
                            that.isShowAllBranchReports = true;
                            that.isShowReport = true;
                        } else if (key == 'dstrReport') {
                            that.isShowDstrReports = true;
                            that.isShowReport = true;
                        } else if (key == 'appoinmentReport') {
                            that.isShowAppoinmentReports = true;
                            that.isShowReport = true;
                        } else if (key == 'stockReport') {
                            that.isShowStockReports = true;
                            that.isShowReport = true;
                        }
                        else if (key == 'Edit') {
                            that.isShowEdit = true;
                        } else if (key == 'Telecaller') {
                            that.isShowTelecaller = true;
                        } else if (key == 'Doctor') {
                            that.isShowDoctor = true;
                        }
                    });
                }
                if (that.HVBill == 'HV') {
                    let tabParams = {
                        tabParams: ""
                    }
                    that.addTab("Transaction", "HVPhoneBillComponent", tabParams, "");
                }
                let tabParam = {
                    tabParams: ""
                }
                that.addTab("","Dashboard",tabParam,"");
            });
    }
    public addTab(tabGroup: string, tabID: any, params: object, tabParams = ''): void {
        //this.tabsComponent = new TabsComponent();
        //let tabObj = _.find(this.menus[tabGroup], { 'id': tabID });
        //if(!_.isEmpty(tabParams)){
        let tabObj = _.find(this.allMenus[tabGroup], { 'id': tabID, 'params': tabParams });
        //}
        var isCloseable = true;//tabObj['isCloseable'];
        if (tabID == "HVPhoneBillComponent") {
            isCloseable = false;
        }
        if (tabID == "Dashboard") {
            isCloseable = false;
        }
        params['tabParams'] = tabParams;
        this.tabsComponent.openTab(tabObj, isCloseable, params);
    }


    onOpenCloseMenu() {
        this.menuIcon = this.sideNavMenu.opened ? 'fa-bars' : 'fa-arrow-left';
        this.sideNavMenu.toggle();
    }
    // filter(groupMenuList) {
    //     let filterMenuList = _.filter(groupMenuList, { 'visible': 'true' });
    //     return filterMenuList;
    // }

    logout() {
        let that = this;
        //this.store.dispatch(new appConfigActions.SetAuth(false));
        //this.router.navigate(['login'], { skipLocationChange: true});
        swal({
            title: "Are you sure?",
            text: "You want to Logout!",
            type: "warning",
            showCancelButton: true,
            confirmButtonText: 'YES',
            //closeOnConfirm: false,
            cancelButtonText: 'NO',
            showLoaderOnConfirm: false,
        }).then(function () {
            that.showMenu = false;
            that.authService
                .logout({})
                .then((res: any) => {
                    if (res.success) {
                        that.showMenu = true;
                        that.comstore.dispatch(new commonActions.IsAuth(true));
                        //localStorage.setItem('currentUser', 'Abdul');
                        that.router.navigate(['login'], { skipLocationChange: true });
                    }
                })
                .catch((error: any) => {
                    console.log(error);
                });
            clearInterval(that.notificationsComponent.notificationCall);
        }, function (dismiss) {
        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/home/home.component.ts